export const INPUT_FMT = 'YYYY-MM-DD';
export const STATS = ['impressions', 'fullViews', 'views', 'engagements', 'likes', 'likesAndSaves', 'comments', 'ctaClicks', 'enquiries'];
export const AUDIENCE_STATS = ['gained', 'lost'];
export const GRANULARITY_TO_DURATION = {
  d: 'days',
  w: 'weeks',
  m: 'months',
};
export const DATE_RANGES = [
  { value: Infinity, label: 'all time' },
  { value: 365, label: '12 months' },
  { value: 182, label: '6 months' },
  ...[90, 30, 14, 7].map(value => ({ value, label: `${value} days` })),
];
